import Image from 'components/shared/image';
import Icon from 'components/shared/icon';
import RichText from 'components/shared/richtext';
import { useSettings } from 'contexts/SettingContext';
import { useAddItemsToCart } from 'hooks';
import { useState } from 'react';
import { formatPriceByStoreLocale } from 'lib/shopify';
import styles from './selectedPopup.module.scss';

const SelectedPopup = ({
  selectedProducts,
  itemsCount,
  removeCallback,
  message,
  resources,
  locale,
  discount,
  itemMessage,
}) => {
  const { addProducts } = useSettings();
  const [isLoading, setIsLoading] = useState(false);
  const {
    freeItem,
    amountOfProductsToGetFreeItem,
    promoCollectionName,
    shopifyTagsToExcludeFromPromo,
  } = resources.secondpartsettings;
  const { addToCart, addingToCart } = resources.productpage;
  const addItems = useAddItemsToCart();

  const handleAddToCart = async () => {
    if (selectedProducts.length < itemsCount) return;

    const bundleId = selectedProducts.reduce(
      (acc, { product }) => acc + product.shopifyData.variants[0].product_id,
      ''
    );

    setIsLoading(true);

    let customAttributes = [];

    if (discount) {
      customAttributes = [
        { key: '_bundle_discount', value: discount.toString() },
        { key: '_bundle_id', value: bundleId },
        {
          key: '_bundle_message',
          value: itemMessage.toUpperCase() || `Bundle discount of ${discount}% applied.`,
        },
      ];
    }

    const productsToAdd = selectedProducts.map(({ productShopifyData }) => ({
      variantId: productShopifyData.variantId,
      quantity: 1,
      customAttributes,
    }));

    try {
      await addItems(productsToAdd, freeItem?.product?.shopifyData, {
        amountOfProductsToGetFreeItem,
        promoCollectionName,
        shopifyTagsToExcludeFromPromo,
      });
    } catch (e) {
      // eslint-disable-next-line
      console.error(e);
    }

    const itemsDataForAddToCart = selectedProducts.map(({ productShopifyData }) => ({
      title: productShopifyData.productTitle,
      slug: productShopifyData.productHandle,
      variantId: productShopifyData.variantId,
    }));

    addProducts(itemsDataForAddToCart);
    setIsLoading(false);
  };

  const Item = ({ product, index }) => (
    <div className={styles.itemImage}>
      {product && (
        <>
          <Image src={product.image} layout="fill" />
          <button type="button" className={styles.closeBtn} onClick={() => removeCallback(index)}>
            <Icon type="close" />
          </button>
        </>
      )}
    </div>
  );

  const items = Array(itemsCount)
    .fill(0)
    .map((_, index) => {
      const selectedProduct = selectedProducts.find(s => s.step === index);
      return <Item product={selectedProduct?.product} index={index} />;
    });

  const ButtonText = () => {
    if (isLoading) {
      return addingToCart?.text;
    }

    const totalPrice = selectedProducts.reduce(
      (acc, { productShopifyData }) => acc + parseFloat(productShopifyData.productPrice),
      0
    );

    const discountedPrice = totalPrice - totalPrice * 0.2;

    return (
      <div className={styles.cartButtonText}>
        {addToCart?.text}

        {totalPrice > 0 && <span>-</span>}
        <span>
          {totalPrice > 0 && (
            <s>
              {formatPriceByStoreLocale({
                locale,
                price: totalPrice,
              })}
            </s>
          )}
        </span>
        {discountedPrice > 0 && (
          <span className={styles.salesPrice}>
            {formatPriceByStoreLocale({
              locale,
              price: discountedPrice,
            })}
          </span>
        )}
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.messageContainer}>
        <RichText text={message?.json} className={styles.message} />
      </div>
      <div className={styles.selectedItems}>{items}</div>
      <div className={styles.addToCart}>
        <button
          type="button"
          disabled={isLoading || selectedProducts.length < itemsCount}
          className={styles.addToCartButton}
          style={{
            backgroundColor: resources?.btncolors?.addToCartButtonColor?.text,
            color: resources?.btncolors?.addToCartButtonTextColor?.text,
          }}
          onClick={() => {
            handleAddToCart();
          }}
        >
          <ButtonText />
        </button>
      </div>
    </div>
  );
};

export default SelectedPopup;
